export default function CTA() {
  return {
    show: false,
    _scrollHandler: null,

    init() {
      this._scrollHandler = () => {
        this.show = window.pageYOffset > 200;
      };
      window.addEventListener('scroll', this._scrollHandler);
    },

    destroy() {
      if (this._scrollHandler) {
        window.removeEventListener('scroll', this._scrollHandler);
      }
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
